module.exports = "/assets/7b4a65b9e7253d83e79b6f2d6113dd52.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/FI.png
// module id = 2496
// module chunks = 0